/** Hızlı teklif: otel satış fiyatı düzenleme ve Booking fiyatı metinleri (Türkçe). */
export const SATIS_FIYATI = {
  baslik: 'Teklif fiyatı',
  sistemFiyati: (tutar: string) => `Sistem fiyatı: ${tutar} (tedarikçi maliyeti + %10)`,
  etiket: 'Bu teklif için satış fiyatı (toplam)',
  yerTutucu: 'Boş bırakırsan sistem fiyatı geçerli',
  aciklama: 'Yalnız bu teklifi etkiler. Seçilen odaların toplamı bu rakama eşitlenir, oda satırları aynı oranda ayarlanır.',
  gecersiz: 'Geçerli bir tutar yazın ya da boş bırakın. Oda seçimi tamam olmalı.',
  sifirla: 'Sistem fiyatına dön',
  gecerli: (tutar: string, fark: string) => `Teklifte geçerli: ${tutar} (sistem fiyatına göre ${fark})`,
  bookingCek: 'Booking fiyatını çek',
  bookingCekiliyor: 'Booking sorgulanıyor, yarım dakika sürebilir',
  bookingYenile: 'Yeniden çek',
  bookingSlugYok: 'Bu otelin kataloğunda adres yok, Booking sorgulanamaz.',
  bookingFiyat: (tutar: string) => `Booking: ${tutar} (en ucuz oda, tüm konaklama)`,
  bookingToplam: (tutar: string, odaSayisi: number) => `Booking toplamı: ${tutar} (${odaSayisi} oda, tüm konaklama)`,
  bookingOdaSatiri: (no: number, konuk: string, odaAdi: string, tutar: string) => `Oda ${no} (${konuk}): ${odaAdi}, ${tutar}`,
  bookingCokOdaSure: 'Her oda Booking\'de ayrı sorulur, birkaç dakika sürebilir.',
  bookingKarsilastirma: (fark: string) => `Sistem fiyatına göre ${fark}`,
  bookingNot: 'Booking vergi dahil ve kendi kampanyasıyla gösterebilir, aynı odaya denk gelmeyebilir. Bilgi amaçlıdır, teklife girmez.',
  bookingZaman: (z: string) => `Alınma zamanı: ${z}`,
  bookingYok: (sebep: string) => sebep,
  bookingZamanAsimi: 'Booking cevabı gecikti, biraz sonra yeniden deneyin.',
  bookingHata: 'Booking fiyatı alınamadı.',
  farkYuksek: (tutar: string) => `${tutar} yüksek`,
  farkDusuk: (tutar: string) => `${tutar} düşük`,
  farkYok: 'aynı',
} as const;
